export default "__VITE_ASSET__9EOAm3f6__"